import angular from 'angular';

angular
  .module('cloudX')
  .controller('ExternalRelationSearchDialogCtrl', [
    '$q',
    'externalRelationHttpSvc',
    'flySvc',
    '$element',
    'close',
    'searchTerm',
    'searchProvider',
    ExternalRelationSearchDialogCtrl,
  ]);

function ExternalRelationSearchDialogCtrl(
  $q,
  externalRelationHttpSvc,
  flySvc,
  $element,
  close,
  searchTerm,
  searchProvider,
) {
  var vm = this;
  vm.canceller = null;
  vm.searchProvider = searchProvider;
  vm.searchTerm = searchTerm || '';
  vm.results = [];

  vm.search = function() {
    if (vm.canceller !== null) {
      vm.canceller.resolve();
      vm.canceller = null;
    }
    vm.results = [];
    if (vm.searchTerm) {
      vm.canceller = $q.defer();
      externalRelationHttpSvc
        .search(vm.searchTerm, 1000, searchProvider, vm.canceller.promise)
        .then(
          function(data) {
            vm.results = data;
            vm.canceller = null;
          },
          function(error) {
            if (error.status === 0) return; //Cancelled
            flySvc.error(error);
            vm.canceller = null;
          },
        );
    }
  };
  if (vm.searchTerm) vm.search();

  vm.select = function(comp) {
    close(comp, 500);
    $element.modal('hide');
  };

  vm.cancel = function() {
    if (vm.canceller !== null) {
      vm.canceller.resolve();
      vm.canceller = null;
    }
    close(null, 500);
  };
}
